import React, { useState, useEffect, useCallback } from 'react';
import ArrowIcon from '@material-ui/icons/ArrowForward';
import AddIcon from '@material-ui/icons/Add';
import {
  TextField,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { setSnackbar, fetchInstitutions, setInstitutionRules } from '../../../../store/index';
import { fetchGet, fetchPut } from '../../../../helpers/fetching';
import { useStyles } from './InstitutionNameRules.style';
import { useTranslation } from 'react-i18next';

export default function InstitutionNameRules(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // Store
  const institution_list = useSelector((state) => state.operators_devices.institution_list);
  const institution_rules = useSelector((state) => state.operators_devices.institution_rules);

  // State
  const [localRules, setLocalRules] = useState({});
  const [newRuleInstitution, setNewRuleInstitution] = useState('');
  const [newRuleName, setNewRuleName] = useState('');

  // Handlers
  const onRuleChange = (name, newName) => {
    const newRules = { ...localRules };
    if (!newName) {
      delete newRules[name];
    } else {
      newRules[name] = newName;
    }
    setLocalRules(newRules);
  };

  const onAddNewRule = () => {
    if (newRuleInstitution && newRuleName.trim()) {
      const newRules = { ...localRules };
      newRules[newRuleInstitution] = newRuleName.trim();
      setLocalRules(newRules);
      setNewRuleInstitution('');
      setNewRuleName('');
    }
  };

  const postRules = async () => {
    const response = await fetchPut('inst_rules', localRules);
    if (response.success) {
      const msgSaved = t('Filters.rulesSaved');
      dispatch(
        setSnackbar({
          msg: msgSaved,
          severity: 'success',
        })
      );
      dispatch(fetchInstitutions());
    } else {
      dispatch(
        setSnackbar({
          msg: `api_messages.${response.msg}`,
          severity: 'error',
        })
      );
    }
  };

  // Effects
  useEffect(() => {
    setLocalRules(institution_rules);
  }, [institution_rules]);

  return (
    <Dialog
      maxWidth='lg'
      className={classes.institutions_dialog}
      open={props.open}
      onClose={props.onClose}
      aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>{t('Filters.nameRules')}</DialogTitle>
      <DialogContent>
        {localRules ? (
          <>
            {Object.entries(localRules).map(([originalName, newName]) => (
              <div key={originalName} className={classes.RuleItem}>
                <p className={classes.left}>{originalName}</p>
                <ArrowIcon className={classes.center} />
                <TextField
                  variant='standard'
                  value={newName}
                  className={classes.right}
                  onChange={(e) => onRuleChange(originalName, e.target.value)}
                />
              </div>
            ))}
            {/* Add new rule */}
            {institution_list.length > 0 && (
              <div
                className={classes.RuleItem}
                style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
                <FormControl variant='standard' className={classes.left}>
                  <InputLabel>Select Institution</InputLabel>
                  <Select value={newRuleInstitution} onChange={(e) => setNewRuleInstitution(e.target.value)}>
                    {institution_list.map((institution) => (
                      <MenuItem key={institution.institution} value={institution.institution}>
                        {institution.institution}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <ArrowIcon className={classes.center} />
                <TextField
                  variant='standard'
                  placeholder='Enter new name'
                  value={newRuleName}
                  className={classes.right}
                  onChange={(e) => setNewRuleName(e.target.value)}
                />
                <IconButton
                  onClick={onAddNewRule}
                  disabled={!newRuleInstitution || !newRuleName.trim()}
                  color='primary'>
                  <AddIcon />
                </IconButton>
              </div>
            )}
          </>
        ) : (
          <CircularProgress />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={postRules} color='primary' variant='contained'>
          {t('Filters.apply')}
        </Button>
        <Button onClick={props.onClose} color='primary' variant='contained'>
          {t('Filters.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
